import algoliasearch from "algoliasearch";
import { Swiper, Navigation, Mousewheel } from "swiper";

import ProductCardRenderer from "../common/product-card-renderer";
const productCardRenderer = ProductCardRenderer();

import Wishlist from "../common/wishlist";
const wishlist = Wishlist();

const renderProducts = (section) => {
  const facetFilters = [];
  facetFilters.push([`tags:-outlet`]);

  const client = algoliasearch("ZGISPFZEQK", "ebbe04351ebe8091e1d417fe4ed7d8b3");
  const algoliaSearchIndex = client.initIndex(section.sortType);
  algoliaSearchIndex
    .search("", {
      clickAnalytics: true,
      facetingAfterDistinct: true,
      distinct: true,
      hitsPerPage: 36,
      page: 0,
      filters: "",
      numericFilters: [],
      facetFilters: facetFilters,
    })
    .then((result) => {
      result.hits.forEach((product) => {
        wishlist.addAlgoliaProductToViewProducts(product);
      });

      const items = result.hits.map((product) => {
        const item = productCardRenderer.renderAlgoliaProduct(product, section.sortType, result.queryID);
        return `<div class="swiper-slide">${item}</div>`;
      });

      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      const swiperElement = sectionElement.querySelector(".swiper");
      const wrapperElement = swiperElement.querySelector(".swiper-wrapper");
      wrapperElement.innerHTML = items.join("");

      const ids = result.hits.map((p) => "gid://shopify/Product/" + p.id);
      window.ShopifyClient.fetchProducts(ids)
        .then((products) => {
          products.forEach((product) => productCardRenderer.addHoverImage(sectionElement, product));
        })
        .catch((e) => {
          /* console.error(e) */
        });

      const searchInsights = require("search-insights");
      searchInsights("init", {
        appId: "ZGISPFZEQK",
        apiKey: "ebbe04351ebe8091e1d417fe4ed7d8b3",
      });
      productCardRenderer.addClickedObjectIDsAfterSearch(sectionElement, searchInsights);
      productCardRenderer.addWishlistButtonListener(sectionElement);
      wishlist.updateButtons();

      section.swiper = new Swiper(swiperElement, {
        modules: [Navigation, Mousewheel],
        centerInsufficientSlides: true,
        speed: 300,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        spaceBetween: 8,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 0.1,
          thresholdDelta: 10,
        },
        navigation: {
          nextEl: sectionElement.querySelector(".fs-swiper-navigation-next"),
          prevEl: sectionElement.querySelector(".fs-swiper-navigation-prev"),
        },
        breakpoints: {
          992: {
            speed: 900,
            slidesPerView: 4.5,
            slidesPerGroup: 4,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          1298: {
            speed: 900,
            slidesPerView: 5.4,
            slidesPerGroup: 5,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
        },
      });
    });
};

const mediaSliderProductsMain = () => {
  if (!window.fstore.sections) {
    return;
  }
  const sectionTypes = ["media-slider-products", "media-slider-products-new"];
  window.fstore.sections
    .filter((section) => sectionTypes.includes(section.sectionType))
    .forEach((section) => {
      renderProducts(section);
    });
};

addEventListener("DOMContentLoaded", (event) => {
  mediaSliderProductsMain();
});
